import Vue from "vue";
import Vuex from "vuex";
import apiService from "@/services/apiService.js";

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		auth: false,
		user: {},
		permissions: [],
		measurementData: [],
		records: [],
		refreshedUser: false,
		refreshedRecords: false,
		allowAllMeasurements: false
	},
	getters: {
		loggedIn: (state) => {
			return state.auth;
		},
		employees: (state) => {
			return state.user.employees;
		},
		userOrgs: (state) => {
			return state.user.orgs;
		},
		getStateRecordByName: (state) => (name) => {
			return state.records.find((record) => record.name === name);
		}
	},
	mutations: {
		SET_SESSION_USER_DATA(state, { token, auth, user, permissions }) {
			apiService.setAxiosBearerHeader(token);
			state.auth = auth;
			state.user = user;
			state.permissions = permissions || []; // Will be [] for a brand new account (e.g. not set up yet)
			localStorage.setItem("savedUserData", JSON.stringify({ token, auth, user, permissions }));
		},
		SET_REFRESHED_USER(state) {
			// Cannot be in SET_SESSION_USER_DATA because that mutation is called in main.js with localStorage data, which is not from server
			state.refreshedUser = true;
		},
		CLEAR_SESSION_USER_DATA() {
			localStorage.removeItem("savedUserData");
			// location.reload();
		},
		ADD_RECORD(state, newRecord) {
			state.records.push(newRecord);
		},
		SET_RECORDS(state, records) {
			state.records = records;
			state.refreshedRecords = true;
		},
		DELETE_RECORD(state, deletedRecord) {
			state.records = state.records.filter((record) => {
				return record._id !== deletedRecord._id;
			});
		},
		ADD_MEASUREMENT_DATA(state, measurementData) {
			state.measurementData.push(measurementData);
		},
		CLEAR_MEASUREMENT_DATA(state) {
			state.measurementData = [];
		},
		SET_ALLOW_ALL_MEASUREMENTS(state) {
			state.allowAllMeasurements = true;
		}
	},
	actions: {
		refresh({ state, dispatch }) {
			if (!state.refreshedUser) {
				dispatch("fetchUserData");
			}
			if (!state.refreshedRecords) {
				dispatch("fetchRecords");
			}
		},
		login({ commit }, userSessionData) {
			commit("SET_SESSION_USER_DATA", userSessionData);
		},
		logout({ commit }) {
			commit("CLEAR_SESSION_USER_DATA");
			this._vm.$auth.logout({
				returnTo: process.env.VUE_APP_BASE_CLIENT_URL
				// returnTo: window.location.origin
			});
		},
		fetchUserData({ dispatch, commit }) {
			return new Promise((resolve, reject) => {
				apiService
					.fetchUserData()
					.then((res) => {
						// Auto-Update
						if (res.data.user.updateRequested && res.data.user.updateRequested > 0) {
							apiService.fulfillUpdateRequest().then(() => dispatch("logout"));
						} else {
							commit("SET_SESSION_USER_DATA", res.data);
							commit("SET_REFRESHED_USER");
						}
					})
					.catch((err) => {
						// Log the user out
						dispatch("logout");
						reject(err.response.data);
					});
			});
		},
		createNewRecord({ commit }, newRecord) {
			return new Promise((resolve, reject) => {
				apiService
					.newRecord(newRecord)
					.then((res) => {
						commit("ADD_RECORD", res.data);
						resolve(res.data);
					})
					.catch((err) => reject(err.response.data));
			});
		},
		fetchRecords({ commit }) {
			return apiService
				.getRecords()
				.then((res) => {
					commit("SET_RECORDS", res.data);
				})
				.catch((err) => {
					throw err.response.data;
				});
		},
		deleteRecord({ commit }, recordID) {
			return new Promise((resolve, reject) => {
				apiService
					.deleteRecord(recordID)
					.then((res) => {
						commit("DELETE_RECORD", res.data);
						resolve(res.data);
					})
					.catch((err) => reject(err.response.data));
			});
		},
		editEmployee({ dispatch }, command) {
			if (command.action === "delete") {
				return apiService
					.deleteEmployee(command)
					.then(() => {
						dispatch("fetchUserData");
					})
					.catch((err) => {
						throw err.response.data;
					});
			} else if (command.action === "add") {
				return apiService
					.addEmployee(command)
					.then(() => {
						dispatch("fetchUserData");
					})
					.catch((err) => {
						throw err.response.data;
					});
			} else if (command.action === "edit") {
				return apiService
					.editEmployee(command)
					.then(() => {
						dispatch("fetchUserData");
					})
					.catch((err) => {
						throw err.response.data;
					});
			} else {
				throw "editEmployee command action not found";
			}
		},
		socket_connect() {
			// console.log("Connected to socket.io");
			// this._vm.$socket.client.emit("test", "bob");
		},
		updateMeasurementData({ state, commit }, measurementData) {
			// Only add measurement data if temperature is above 96.0
			if (measurementData.oTemp > 96.0 || state.allowAllMeasurements) {
				commit("ADD_MEASUREMENT_DATA", measurementData);
			}
		},
		emptyMeasurementData({ commit }) {
			commit("CLEAR_MEASUREMENT_DATA");
		},
		demoSimulateDevice() {
			return apiService.demoSimulateDevice();
		}
	},
	modules: {}
});
